class SevenKTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
    if (!this.tabs.length) return;
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.activate(next, true);
      });
    });
    this.activate(Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')));
  }

  activate(index, focus = false) {
    this.tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      this.panels[tabIndex]?.toggleAttribute('hidden', !active);
    });
    if (focus) this.tabs[index]?.focus();
  }
}

if (!customElements.get('sevenk-tabs')) customElements.define('sevenk-tabs', SevenKTabs);

class SevenKPersonalization extends HTMLElement {
  connectedCallback() {
    this.productInfo = this.closest('product-info');
    this.handleChange = this.handleChange.bind(this);
    this.productInfo?.addEventListener('change', this.handleChange);
    this.update();
  }

  disconnectedCallback() {
    this.productInfo?.removeEventListener('change', this.handleChange);
  }

  handleChange(event) {
    const optionName = event.target?.dataset?.optionName || event.target?.name || '';
    if (optionName.toLocaleLowerCase('pt-BR').includes('personaliza')) this.update();
  }

  selectedValue() {
    const controls = [...(this.productInfo?.querySelectorAll('input[data-option-name], select[name^="options["]') || [])];
    const personalization = controls.filter((control) =>
      (control.dataset.optionName || control.name || '').toLocaleLowerCase('pt-BR').includes('personaliza'),
    );
    const checked = personalization.find((control) => control.checked);
    const selected = personalization.find((control) => control.tagName === 'SELECT');
    return (checked?.value || selected?.value || '').trim().toLocaleLowerCase('pt-BR');
  }

  update() {
    const enabled = this.selectedValue().startsWith('personalizar');
    this.hidden = !enabled;
    this.querySelectorAll('input').forEach((input) => {
      input.disabled = !enabled;
      input.required = enabled;
      if (!enabled) input.value = '';
    });
  }
}

if (!customElements.get('sevenk-personalization')) {
  customElements.define('sevenk-personalization', SevenKPersonalization);
}

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-sevenk-size-guide-open]');
  if (openButton) {
    const dialog = document.getElementById(openButton.dataset.sevenkSizeGuideOpen);
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }

  const closeButton = event.target.closest('[data-sevenk-size-guide-close]');
  if (closeButton) {
    closeButton.closest('dialog')?.close();
    return;
  }

  if (event.target.matches('.sevenk-size-guide-dialog')) event.target.close();
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-sevenk-filter-toggle]');
  if (!button) return;

  const filters = document.getElementById(button.getAttribute('aria-controls'));
  const layout = filters?.closest('.facets-vertical');
  if (!filters || !layout) return;

  const isOpen = layout.classList.toggle('sevenk-filters-open');
  button.setAttribute('aria-expanded', String(isOpen));
  const label = button.querySelector('[data-sevenk-filter-label]');
  if (label) label.textContent = isOpen ? 'Fechar filtros' : 'Abrir filtros';
  if (isOpen) filters.querySelector('summary, input, button')?.focus();
});
